import { render, staticRenderFns } from "./SubMerchantRegister.vue?vue&type=template&id=637bf88a&scoped=true"
import script from "./SubMerchantRegister.vue?vue&type=script&lang=js"
export * from "./SubMerchantRegister.vue?vue&type=script&lang=js"
import style0 from "./SubMerchantRegister.vue?vue&type=style&index=0&id=637bf88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637bf88a",
  null
  
)

export default component.exports